import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

const calcularValorLiquidoPF = (dadosPagamento, impostosTaxas) => {
    let IRRFAPagar = 0;  
    let INSSAPagar = 0;
    let ISSAPagar = 0;
    let INSSAPagarRetencao = 0;
    let COFINS = 0;
    let PIS = 0;
    let CSLL = 0;

    let valorPagarLiquido = 0;
    let valorBase = 0;
    let valorBaseISS = 0;
    let aliquotaISS = 0;

    if (dadosPagamento.valorINSSPatronal > 0 && dadosPagamento.isINSS) {
        INSSAPagar = dadosPagamento.valorINSSPatronal - (dadosPagamento.valorINSSPatronal / ((100 + impostosTaxas.AliquotaINSSPessoal) / 100));
        valorBase = (dadosPagamento.valorINSSPatronal / ((100 + impostosTaxas.AliquotaINSSPessoal) / 100));
    } else {
        valorBase = dadosPagamento.valorBase;
    }

    valorPagarLiquido = valorBase;
    valorBaseISS = dadosPagamento.baseCalculoISS > 0 ? dadosPagamento.baseCalculoISS : valorBase;
    aliquotaISS = impostosTaxas.AliquotaISS !== dadosPagamento.taxaISS ? dadosPagamento.taxaISS : impostosTaxas.AliquotaISS;

    // INSS
    if (dadosPagamento.isINSSRetencao) {
        INSSAPagarRetencao = valorBase * (impostosTaxas.AliquotaINSSRetencao / 100);
        valorPagarLiquido -= INSSAPagarRetencao;
    }
    const valorBaseSemINSS = valorBase - INSSAPagarRetencao;

    //IRRF
    if (dadosPagamento.isIRRF) {
        if ((valorBaseSemINSS) <= impostosTaxas.LimiteIRRFFaixa1) {
            IRRFAPagar = ((valorBaseSemINSS) * (impostosTaxas.AliquotaIRRFFaixa1 / 100)) - impostosTaxas.ValorADeduzirFaixa1;
        } else if ((valorBaseSemINSS >= impostosTaxas.LimiteIRRFFaixa2Inf) && (valorBaseSemINSS <= impostosTaxas.LimiteIRRFFaixa2Sup)) {
            IRRFAPagar = (valorBaseSemINSS * (impostosTaxas.AliquotaIRRFFaixa2 / 100)) - impostosTaxas.ValorADeduzirFaixa2;
        } else if ((valorBaseSemINSS >= impostosTaxas.LimiteIRRFFaixa3Inf) && (valorBaseSemINSS <= impostosTaxas.LimiteIRRFFaixa3Sup)) {
            IRRFAPagar = (valorBaseSemINSS * (impostosTaxas.AliquotaIRRFFaixa3 / 100)) - impostosTaxas.ValorADeduzirFaixa3;
        } else if ((valorBaseSemINSS >= impostosTaxas.LimiteIRRFFaixa4Inf) && (valorBaseSemINSS <= impostosTaxas.LimiteIRRFFaixa4Sup)) {
            IRRFAPagar = (valorBaseSemINSS * (impostosTaxas.AliquotaIRRFFaixa4 / 100)) - impostosTaxas.ValorADeduzirFaixa4;
        } else if (valorBaseSemINSS > impostosTaxas.LimiteIRRFFaixa5) {
            IRRFAPagar = (valorBaseSemINSS * (impostosTaxas.AliquotaIRRFFaixa5 / 100)) - impostosTaxas.ValorADeduzirFaixa5;
        }
        valorPagarLiquido -= IRRFAPagar;
    }

    // ISS
    if (dadosPagamento.isISS) {
        ISSAPagar = valorBaseISS * (aliquotaISS / 100);
        valorPagarLiquido -= ISSAPagar;
    }

    return {
        valor_calculado: parseFloat(valorPagarLiquido),
        iss: {
            valor: parseFloat(valorBaseISS),
            aliquota: parseFloat(aliquotaISS),
        }
    };
}

const calcularValorBrutoPF = (dadosPagamento, impostosTaxas) => {
    let valorLiquidoEsperado = dadosPagamento.valorBase;
    let valorLiquidoCalculado = {};
    let valorPagarBruto = dadosPagamento.valorBase * 1.7;
    let diferencaValor = valorLiquidoEsperado - valorPagarBruto;

    dadosPagamento.valorBase = valorPagarBruto;
    dadosPagamento.valorINSSPatronal = valorPagarBruto;
    
    while (Math.abs(diferencaValor) > 0.005) {
        valorLiquidoCalculado = calcularValorLiquidoPF(dadosPagamento, impostosTaxas);
        diferencaValor = valorLiquidoEsperado - valorLiquidoCalculado.valor_calculado;

        if (diferencaValor > 0) {
            if (diferencaValor >= 100) valorPagarBruto += 50.0;
            else if (diferencaValor >= 10) valorPagarBruto += 5.0;
            else if (diferencaValor >= 1) valorPagarBruto += 0.50;
            else if (diferencaValor >= 0.1) valorPagarBruto += 0.05;
            else if (diferencaValor > 0.005) valorPagarBruto += 0.01;
        }
        if (diferencaValor < 0) {
            if (diferencaValor <= -100) valorPagarBruto -= 50.0;
            else if (diferencaValor <= -10) valorPagarBruto -= 5.0;
            else if (diferencaValor <= -1) valorPagarBruto -= 0.50;
            else if (diferencaValor <= -0.1) valorPagarBruto -= 0.05;
            else if (diferencaValor < -0.005) valorPagarBruto -= 0.01;
        }
        dadosPagamento.valorBase = valorPagarBruto;
        dadosPagamento.valorINSSPatronal = valorPagarBruto;
    }

    return {
        valor_calculado: parseFloat(valorPagarBruto),
        iss: {
            valor: parseFloat('iss' in valorLiquidoCalculado ? valorLiquidoCalculado.iss.valor : dadosPagamento.valorBase),
            aliquota: parseFloat('iss' in valorLiquidoCalculado ? valorLiquidoCalculado.iss.aliquota : impostosTaxas.AliquotaISS),
        }
    };
}

export default {
    obterImpostosTaxas: async () => {
        const impostosTaxas = await Vue.http.get('/api/impostostaxas/buscar');
        return impostosTaxas.data;
    },
    calcularValorFinal: (dadosPagamento, impostosTaxas) => {
        dadosPagamento.valorINSSPatronal = dadosPagamento.valorINSSPatronal ? dadosPagamento.valorINSSPatronal.toString().replace(/,/g, '.') : 0;
        dadosPagamento.baseCalculoISS = dadosPagamento.baseCalculoISS ? dadosPagamento.baseCalculoISS.toString().replace(/,/g, '.') : 0;
        dadosPagamento.taxaISS = dadosPagamento.taxaISS ? dadosPagamento.taxaISS.toString().replace(/,/g, '.') : 0;
        dadosPagamento.valorFinal = dadosPagamento.valorFinal ? dadosPagamento.valorFinal.toString().replace(/,/g, '.') : 0;
        dadosPagamento.valorBase = dadosPagamento.valorBase ? dadosPagamento.valorBase.toString().replace(/,/g, '.') : 0;

        if (dadosPagamento.tipoCalculo === 'liquido' && dadosPagamento.tipoPessoa === 'fisica') {
            const dadosPagamentoClone = JSON.parse(JSON.stringify(dadosPagamento));
            return calcularValorBrutoPF(dadosPagamentoClone, impostosTaxas);
        }
        if (dadosPagamento.tipoCalculo === 'bruto' && dadosPagamento.tipoPessoa === 'fisica') {
            return calcularValorLiquidoPF(dadosPagamento, impostosTaxas);
        }
        return 2;
    },
};



// WEBPACK FOOTER //
// ./FrontEnd/modulos/simulacao-pagamento/servico.js